import { Box, Tab, Tabs } from '@mui/material';
import React, { useContext } from 'react';

import { LocaleContext } from '@/Contexts/LocaleContext';
import AdminSectionHeader from '../AdminSectionHeader';
import SendEmail from './SendEmail';
import EmailActivity from './EmailActivity';

type ApplicationTab = 'emailActivity' | 'sendEmail';

const ManageEmails: React.FC = () => {
  const { translatedText } = useContext(LocaleContext);
  const [activeTab, setActiveTab] = React.useState<ApplicationTab>('emailActivity');

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <AdminSectionHeader title={translatedText.admin.emailsHeader} />
      <Tabs
        value={activeTab}
        onChange={(_, value: ApplicationTab) => setActiveTab(value)}
        sx={{
          borderBottom: 1,
          borderColor: 'divider',
          px: 2,
          backgroundColor: 'background.default',
        }}
      >
        <Tab label={translatedText.admin.tabEmailActivity} value='emailActivity' />
        <Tab label={translatedText.admin.tabSendEmail} value='sendEmail' />
      </Tabs>
      <Box sx={{ p: 2, flexGrow: 1, minHeight: 0, overflowY: 'auto' }}>
        {activeTab === 'emailActivity' && <EmailActivity />}
        {activeTab === 'sendEmail' && <SendEmail />}
      </Box>
    </Box>
  );
};

export default ManageEmails;
